export interface CapabilityMatrix {
  background_sync_supported: boolean;
  persistent_storage_supported: boolean;
  storage_estimate_supported: boolean;
  geolocation_supported: boolean;
  camera_supported: boolean;
  wake_lock_supported: boolean;
  web_locks_supported: boolean;
  broadcast_channel_supported: boolean;
  bluetooth_supported: boolean;
}

export function detectCapabilities(): CapabilityMatrix {
  const nav = navigator as any;
  return {
    background_sync_supported: typeof (globalThis as any).SyncManager !== 'undefined',
    persistent_storage_supported: !!navigator.storage && typeof navigator.storage.persist === 'function',
    storage_estimate_supported: !!navigator.storage && typeof navigator.storage.estimate === 'function',
    geolocation_supported: 'geolocation' in navigator,
    camera_supported: !!navigator.mediaDevices?.getUserMedia,
    wake_lock_supported: !!nav.wakeLock,
    web_locks_supported: !!nav.locks?.request,
    broadcast_channel_supported: typeof BroadcastChannel !== 'undefined',
    bluetooth_supported: !!nav.bluetooth,
  };
}
